module.exports = __webpack_public_path__ + "static/media/kfw_1.3845a397.png";